export const SIDEBAR_UPDATE_VISIBILITY = 'SIDEBAR_UPDATE_VISIBILITY';
export const SIDEBAR_UPDATE_ACTIVE_BUTTON = 'SIDEBAR_UPDATE_ACTIVE_BUTTON';
export const SIDEBAR_SET_ELEMENT = 'SIDEBAR_SET_ELEMENT';
export const SIDEBAR_RESET_STATE = 'SIDEBAR_RESET_STATE';



/** WEBPACK FOOTER **
 ** ./src/store/modules/sidebar/types.js
 **/